/**********************************************************************
 * 01. Business Classification  : 팝업
 * 02. Program Title            : 이슈등록 팝업
 * 03. Description              : 이슈등록 등록,수정한다.
 * 04. Creation Date            : 2022.08.16
 * 05. Author                   : jaejin
 * 06. Written History          : 1.최초작성
 **********************************************************************/
/**********************************************************************
 * ▷ Component Import Section
 **********************************************************************/
import React, { useEffect } from "react";
import * as reportcomm from "../../assets/ubi4/js/ReportCommon";
import styled from "styled-components";

/**********************************************************************
 * ▷ Styled Component Section
 **********************************************************************/
const Container = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  animation: fadeInBg .3s ease-in;

  .boxWrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;
    animation: zoomin .3s both cubic-bezier(0.4, 0, 0, 1.5);

    .topBox {
      display: flex;
      justify-content: space-between;
      padding: 1rem;
      background-color: #eff2f7;
      border-radius: 10px 10px 0 0;

      .modalTitle {
        border-left: 3px solid #1a3670;
        padding: 0 0 1px 10px ;
        span {
          font-size: 14px;
          font-weight: 600;
          color: #1a3670;
        }
      }
    }

    .searchBox {
      padding: 20px 10px 10px;
    }

    .contentBox {
      width: 1600px;
      height: 900px;
      padding: 1rem;
    }

    .bottomBox {
      padding: 1rem;
    }

  }
  @keyframes fadeInUp {
    0% {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }
    to {
      opacity: 1;
      transform: translateZ(0);
    }
  }

  @keyframes fadein {
    from {
      opacity:0;
    }
    to {
      opacity:1;
    }
  }

  @keyframes fadeInBg {
    from {
      opacity: 0;
    }
  }

  @keyframes fadeOutBg {
    to {
      opacity: 0;
    }
  }

  @keyframes zoomin {
    from {
      transform: scale3d(0.3, 0.3, 0.3);
    }
  }

  @keyframes zoomout {
    to {
      opacity:0;
      transform: scale(0,0);
    }
  }

  @keyframes rotate-vert-center{0%{transform:rotateY(0)}100%{transform:rotateY(360deg)}}
`;

/**********************************************************************
 * ▷ Interface Section
 **********************************************************************/
// interface IProps {
//   jrffile: string;
//   arg: string;
//   serviceapiurl: string;
//   password: string;
//   label: string;
//   excelFileNm?: string;
//   admnNm?: string;
//   setOpen: any;
// }
/**********************************************************************
 * ▷ Component Body Section
 **********************************************************************/

function ReportPop(props) {
  const {
    jrffile,
    arg,
    serviceapiurl,
    password,
    label,
    excelFileNm = "",
    admnNm = "",
    setOpen
  } = props;
  useEffect(() => {
    console.log(process.env.NODE_ENV)
    reportcomm.CallReport(jrffile, arg, {}, "UbiEFormViewerDiv", serviceapiurl, password, `${excelFileNm + admnNm}_${label}`);
  }, []);

  const handleCancelButtonClick = () => {
    const modal = document.querySelector("#popupContainer");
    const modalBox = modal?.children[0];

    if (modal) {
      modal.style.animation = "fadeOutBg .3s ease-out";
      modalBox.style.animation = "zoomout .3s";
    }
    setTimeout(() => { setOpen(false); }, 200);
  };

  return (
    <>
      <Container id="popupContainer">
      <div className="boxWrapper">
        <div className="topBox">
          <div className="modalTitle">
            <span>{label}</span>
          </div>
          <button type="button" onClick={handleCancelButtonClick}>
            <span>X</span>
          </button>
        </div>
        <div className="contentBox">
          <div
            id="UbiEFormViewerDiv"
          />
        </div>
      </div>
      </Container>
    </>
  );
}

export default ReportPop;
